App.controller('setupInsurancesPopup', (Perm, $scope, $rootScope, $api, responseHelper, ngDialog, InsurancePlan, FileUploader, SERVER_BASE_URL, authService, $timeout) => {

  $scope.addEmptyInsurance = () => {
    if($scope.provider){
      new_params = {parent_id: $scope.provider.id, parent_type: 'User'}
    } else {
      new_params = {parent_id: $rootScope.location.id, parent_type: 'Location'}
    }
    $scope.insurance_plans.push({newly_added: true})
    $scope.no_visible_insurance_plans = false
  }

  $scope.loadInsurances = (plan_name=null) => {
    if(plan_name){
      search_params = {name: plan_name}
    } else {
      $scope.loading = true
      search_params = {online_booking_customization: true}
      if($scope.provider){
        search_params = _.merge(search_params, {provider_id: $scope.provider.id})
      } else {
        search_params = _.merge(search_params, {location_id: $rootScope.location.id})
      }
    }

    var search_resp = InsurancePlan.$search(search_params)
    return search_resp.$promise.then(data => {
      if(plan_name){
        return search_resp.$response.data.data
      } else {
        $scope.insurance_plans = search_resp.$response.data.data
        if($scope.insurance_plans && $scope.insurance_plans.length){
          $scope.no_visible_insurance_plans = false
        }
        $scope.loading = false
      }
    })
  }

  $scope.onSelectInsurancePlan = (plan, picked_plan) => {
    plan.newly_added = true
    plan.id = picked_plan.id
    plan.name = picked_plan.name
    $scope.no_visible_insurance_plans = false
  }

  $scope.destroyInsurance = (plan) => {
    plan._destroy = true
    if(_.filter($scope.insurance_plans, (plan) => {return !plan._destroy})[0]){
      $scope.no_visible_insurance_plans = false
    } else {
      $scope.no_visible_insurance_plans = true
    }
  }

  // save manually added

  $scope.saveInsurancePlans = () => {
    if(!validateInsurancePlans()){return}
    $scope.insurance_plans_saving = true
    formatInsurancePlans()

    if($scope.provider){
      insurance_plans_params = {provider_id: $scope.provider.id}
    } else {
      insurance_plans_params = {location_id: $rootScope.location.id}
    }
    insurance_plans_opts = _.map($scope.insurance_plans, (ip) => {
      return _.pick(ip, 'id', 'name', 'all_locations_id', '_destroy')
    })
    insurance_plans_params = _.merge(insurance_plans_params, {insurance_plans: insurance_plans_opts})
    $api('POST', `/insurance_plans/bulk_upload/`, {}, insurance_plans_params).then((resp) => {
      if(resp.data.code){
        if(typeof($scope.closeThisDialog) == 'function'){
          $scope.closeThisDialog({ saved: true, insurance_plans: resp.data.data })
        }
      } else {
        $scope.uploading_errors = resp.data.error
      }
      $scope.insurance_plans_saving = false
    })
  }

  validateInsurancePlans = () => {
    validation = true
    _.each($scope.insurance_plans, (ip) => {
      if(ip._destroy){ return }
      errors = []
      plans_by_name = _.filter($scope.insurance_plans, (plan) => {return !plan._destroy && plan.name && ip.name && plan.name.trim().length && plan.name.trim().toLowerCase() == ip.name.trim().toLowerCase()})
      if(plans_by_name.length > 1){
        errors.push(`Please remove the duplicates`)
      }
      if(errors.length){
        validation = false
        ip.errors = errors
      }
    })
    return validation
  }

  formatInsurancePlans = () => {
    $scope.insurance_plans = _.filter($scope.insurance_plans, (plan) => {
      // filter out those which are newly created and destroyed at the same time
      if(plan.id || !plan._destroy){
        return plan
      }
    })

    _.each($scope.insurance_plans, (plan) => {
      // if 'for all location' is chosen - pass all_locations_ids (for available locations) as a parameter
      if(plan.for_all_locations){
        plan.all_locations_id = _.map($rootScope.locations, 'id')
      }
    })
  }

  // CSV Upload

  set_uploader = () => {
    uploader_url = `${SERVER_BASE_URL}/insurance_plans/csv_upload?subdomain=${authService.getUserSubdomain()}`
    if($scope.provider){
      form_data = {provider_id: $scope.provider.id}
    } else if($scope.location){
      form_data = {location_id: $rootScope.location.id}
    } else {
      form_data = {}
    }
    $scope.uploader = new FileUploader({
      url: uploader_url,
      headers: {
        'Authorization': authService.getUserAuthorizationHeader()
      },
      formData: [form_data],
      removeAfterUpload: true,
      autoUpload: false
    })
    $scope.uploader.onSuccessItem = (item, response, status, headers) => {
      $scope.uploading = false
      $scope.attachment = null
      if(response.code){
        _.each(response.data, (new_plan) => {
          new_plan.just_uploaded = true
          $scope.insurance_plans.unshift(new_plan)
        })
        if($scope.no_visible_insurance_plans && $scope.insurance_plans.length){
          $scope.no_visible_insurance_plans = false
        }
        $scope.initialize(true, false) // redirect to 'Manual input' tab without reloading the insurance plans
        $timeout(() => { // to be sure 'initialize' is already fired
          $scope.uploading_errors = response.description
        }, 100)
      } else {
        $scope.uploading_errors = response.error
      }
    }
    $scope.uploader.onBeforeUploadItem = (item) => {
      $scope.uploading = true
    }
    $scope.uploader.onErrorItem = (item, response, status, headers) => {
      $scope.uploading = false
      $scope.uploading_errors = response.error
    }
    $scope.uploader.onAfterAddingFile = (item) => {
      $scope.attachment = item.file
    }
  }

  $scope.uploadCSV = () => {
    if($scope.csv.for_all_locations){
      $scope.uploader.queue[0].formData.push({'all_locations_id': _.map($rootScope.locations, 'id')})
    }
    $scope.uploader.queue[0].upload()
  }


  // init

  $scope.is_inst_admin = Perm.is_inst_admin

  if($scope.ngDialogData && $scope.ngDialogData.provider){
    $scope.provider = $scope.ngDialogData.provider
  }
  set_uploader()

  $scope.initialize = (manual_input = true, load_insurances = true) => {
    $scope.uploading_errors = null
    if(manual_input){
      $scope.activePill = 0
      if(load_insurances){
        $scope.loadInsurances()
      }
    } else {
      $scope.csv = {for_all_locations: false}
      $scope.activePill = 1
    }
  }

  $scope.initialize()
})
